export const iconFontAwesomeDesignEraser = (
	<i className="fa-solid fa-eraser"></i>
);
